module.exports = __webpack_public_path__ + "static/media/Holy Cross Newsletter April 2026.6e7f7751.pdf";